/**
 * Returns whether variable is a string
 * https://stackoverflow.com/questions/4059147/check-if-a-variable-is-a-string-in-javascript
 *
 * @returns boolean
 */
export const isString = aVar =>
  Object.prototype.toString.call(aVar) === '[object String]'

/**
 * Normalises a string
 *
 * @returns string
 */
export const normaliseStr = str => str.toLowerCase().trim()

/**
 * Checks if object is empty
 *
 * @returns boolean
 */
export const isObjEmpty = obj =>
  obj && // null and undefined check
  Object.keys(obj).length === 0 &&
  Object.getPrototypeOf(obj) === Object.prototype

/**
 * Format eth address
 *
 * @returns boolean
 */
export const formatAddress = (addr, startLen = 6, totalLen = 13) => {
  return (
    addr.slice(0, startLen) +
    '...' +
    addr.slice(addr.length - (totalLen - startLen - 3))
  )
}

/**
 * Checks if both objects are equal
 * Fast but limited (sensitive to the order of props)
 *
 * @returns boolean
 */
export const isEqual = (obj1, obj2) =>
  JSON.stringify(obj1) === JSON.stringify(obj2)
